import React from "react";
import { Clock, Loader, CheckCircle, XCircle, FileText } from "lucide-react";
import Mo3tiStatCard from "../../(User)salary_Final/components/Mo3tiStatCard";

const getStatusColor = (status, theme) => {
  switch (status) {
    case "approved": return theme === "dark" ? "#10b981" : "#059669";
    case "pending":  return theme === "dark" ? "#f59e0b" : "#d97706";
    case "rejected": return theme === "dark" ? "#ef4444" : "#dc2626";
    default:         return theme === "dark" ? "#2e7cba" : "#2e7cba";
  }
};

const StatsGrid = ({ stats, theme, language, isRTL, t, lastRefresh, isAutoRefreshing }) => {
  const statsGridStyle = {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(min(200px, 100%), 1fr))",
    gap: "clamp(16px, 3vw, 24px)",
    marginBottom: "32px",
    direction: isRTL ? "rtl" : "ltr",
  };

  const statItems = [
    { label: t.pendingRequests || "Pending Requests", value: stats.pending, status: "pending", icon: Clock },
    { label: t.approved || "Approved",        value: stats.approved, status: "approved", icon: CheckCircle },
    { label: t.rejected || "Rejected",        value: stats.rejected, status: "rejected", icon: XCircle },
    { label: t.totalRequests || "Total Requests",   value: stats.total,    color: "#2e7cba", icon: FileText },
  ];

  return (
    <div>
      <div className="nx-kpi-grid" style={statsGridStyle}>
        {statItems.map((stat, index) => (
          <Mo3tiStatCard
            key={index}
            icon={stat.icon}
            value={stat.value}
            label={stat.label}
            color={stat.color || getStatusColor(stat.status, theme)}
            theme={theme}
            isRTL={isRTL}
          />
        ))}
      </div>
    </div>
  );
};

export default StatsGrid;